import { NavigationButton, RecentActivity } from "@components";
import { Box, List, ListItem, Typography } from "@mui/material";
import { useActivityFlowContext } from "@context/ActivityFlowContext";
import { dashboardData } from "@data";
import dumbbellIcon from "@assets/dumbbell.svg";
import { getActivityById } from "@utils/helperFunctions";
import { theme } from "@theme";

export const DashboardView = () => {
  const { startPreferences, completedActivities } = useActivityFlowContext();
  const recentActivities = [...completedActivities]
    .reverse()
    .flatMap(({ activityId, level }) => {
      const activity = getActivityById(activityId);
      return activity ? [{ activity, level }] : [];
    });
  const { intro, subtitle, buttonText, prompt, steps } = dashboardData;

  return (
    <Box component="section" className="dashboard">
      <Box className="dashboard-card">
        <Box className="dashboard-icon" aria-hidden="true">
          <img src={dumbbellIcon} alt="" />
        </Box>
        <Typography variant="h1" sx={{ mx: "auto", mb: 1.5 }}>
          {subtitle}
        </Typography>
        <Typography variant="body1" sx={{ pb: 3, mx: "auto" }}>
          {intro}
        </Typography>
        <NavigationButton
          className="dashboard-button"
          type="button"
          onClick={startPreferences}
        >
          {buttonText}
        </NavigationButton>
        <Typography variant="body1" sx={{ my: 1.75 }}>
          {prompt}
        </Typography>
        <List component="ol" className="dashboard-steps">
          {steps.map((step) => (
            <ListItem key={step} disablePadding>
              {step}
            </ListItem>
          ))}
        </List>
      </Box>
      {recentActivities.length > 0 && (
        <Box
          component="section"
          className="dashboard-card"
          aria-labelledby="recent-practice-heading"
        >
          <Typography
            variant="h2"
            id="recent-practice-heading"
            sx={{ fontSize: "16px", fontWeight: 700 }}
          >
            Your Recent Practice
          </Typography>
          <List
            disablePadding
            sx={{
              mt: 3,
              p: { xs: 2, sm: 3 },
              display: "grid",
              gap: 2,
              borderRadius: 5,
              background: theme.palette.info.light,
            }}
          >
            {recentActivities.map(({ activity, level }) => (
              <RecentActivity key={activity.id} activity={activity} level={level} />
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};
